/** Who may open which platform page — one set of rules for the sidebar and the route guards. */
import { ACTION, type AuthUser, can, ORG_RESOURCE, PLATFORM_ROLE } from '@daka/core';

export const isPlatformAdmin = (user: AuthUser): boolean => user.role === PLATFORM_ROLE.PLATFORM_ADMIN;
export const canManageMembers = (user: AuthUser): boolean => can(user.permissions, ORG_RESOURCE.MEMBER, ACTION.CREATE);
export const canManageSso = (user: AuthUser): boolean => can(user.permissions, ORG_RESOURCE.ORGANIZATION, ACTION.UPDATE);
